import { IIconDefinition } from '@thx/ui/icons';

export const Chat: IIconDefinition = {
  name: 'chat',
  icon: '      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">\n' +
    '        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"\n' +
    '              fill="currentColor"/>\n' +
    '      </svg>',
};
